import { IFace } from "../interfaces/IFacial";
import api from "../services/mobile/api";

class FaceAPI 
{
    add = async (request: IFace) => await api.post('/chaveVirtual/facial', request);
    remove = async (id: string) => await api.delete(`/chaveVirtual/facial/${id}`);
}

export default new FaceAPI();